import {CreateAbility, createMongoAbility, MongoAbility} from '@casl/ability';
import {CommonAbilities, CRUD} from '@scalified-monorepo/shared/casl';
import {SampleSubject} from './subjects';

// Define strict action-subject combinations for compile-time validation
export type SampleAppAbilities =
  // Sample domain
  | [CRUD, SampleSubject]

  // Common abilities applicable across multiple domains
  | CommonAbilities;

export type SampleAppAbility = MongoAbility<SampleAppAbilities>;

// ✅ Create typed ability factory for type-safe builder
export const createSampleAppAbility = createMongoAbility as CreateAbility<SampleAppAbility>;
